<template>
<div>

  <!--<div class="newcardblock">
    <div class="cardheading">E-SIGNATURE:</div>
    <div class="bgmsgblock">OTP will be send to registered mobile number <b>99******89</b></div>
    <div class="divblock floatright">
      <div class="divblock_list"><button class="btn section_sbtn btn_dark">Send OTP</button></div>
    </div>
  </div>

    <div class="newcardblock">
      <div class="cardheading">E-SIGNATURE:</div>
      <div class="bgmsgblock">OTP will be send to registered mobile number <b>99******89</b></div>
      <div class="divblock floatright">
        <div class="divblock_list"><input type="number"></div>
        <div class="divblock_list"><button class="btn section_sbtn btn_dark">Verify</button></div>
        <div class="linkblock"><span class="link">Resend OTP</span></div>
      </div>
    </div>

    <div class="newcardblock">
      <div class="cardheading">E-SIGNATURE:</div>
      <div class="row">
        <div class="col-lg-6">
          <div class="signfield">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row seclabelgrid">
            <div class="col-5 no-padding">
              <div class="secprimarylabel">Date</div>
            </div>
            <div class="col-5 no-padding">
              <div class="secprimarylabel">15/02/2019</div>
            </div>
          </div>
          <div class="row seclabelgrid">
            <div class="col-5 no-padding">
              <div class="secprimarylabel">Name</div>
            </div>
            <div class="col-5 no-padding">
              <div class="secprimarylabel">Vidya Acharya</div>
            </div>
          </div>
          <div class="row seclabelgrid">
            <div class="col-5 no-padding">
              <div class="secprimarylabel">Time</div>
            </div>
            <div class="col-5 no-padding">
              <div class="secprimarylabel">05:29PM</div>
            </div>
          </div>
          <div class="row seclabelgrid">
            <div class="col-5 no-padding">
              <div class="secprimarylabel">Location</div>
            </div>
            <div class="col-5 no-padding">
              <div class="secprimarylabel">Chennai</div>
            </div>
          </div>
          <div class="row seclabelgrid">
            <div class="col-5 no-padding">
              <div class="secprimarylabel">IP Address</div>
            </div>
            <div class="col-5 no-padding">
              <div class="secprimarylabel">192.0.0.0/24</div>
            </div>
          </div>
        </div>
      </div>
    </div>-->

    <div class="newcardblock">
      <div class="row labelgrid" style="height:15px">
        <div class="col-6 no-padding">
          <div class="cardheading">{{ $t('REMARKS') }}:</div>
        </div>
        <div class="col-6 no-padding floatright">
          <div class="primarylabel">{{ remark.length }} / 200</div>
        </div>
      </div>
      <div class="divblock bgtextarea">
        <textarea :value="remark" rows="5" :maxlength="200" @input="$emit('updateValue','remark', $event.target.value)"/>
      </div>
    </div>
    <div class="newcardblock" style="border:1px solid #24242e">
      <div class="col-6 no-padding">
        <div class="cardheading">{{ $t('CREDIT_NOTE_ATTACH') }}</div>
      </div>
      <Attachments
        :attachments="cnAttachments"
        :showPreview="true"
        :maxAllowed="cnDnAttachmentLimit"
        :multiple=true
        :invoiceAttach="true"
        :allowDelete="true"
        :disableUpload="disableCnUpload"
        :allowedFileFormats="allowedFileFormats"
        :isDarkBg="true"
        @addAttachments="addAttachments($event, attachmentParentType.CREDIT_NOTE)"
        @removeAttachments="removeAttachments($event, attachmentParentType.CREDIT_NOTE)" />
    </div>
      <div class="newcardblock mt-20" style="border:1px solid #24242e">
        <div class="col-6 no-padding">
        <div class="cardheading">{{ $t('DEBIT_NOTE_ATTACH') }}</div>
      </div>
      <Attachments
        :attachments="dnAttachments"
        :showPreview="true"
        :maxAllowed="cnDnAttachmentLimit"
        :multiple=true
        :invoiceAttach="true"
        :allowDelete="true"
        :disableUpload="disableDnUpload"
        :allowedFileFormats="allowedFileFormats"
        :isDarkBg="true"
        @addAttachments="addAttachments($event, attachmentParentType.DEBIT_NOTE)"
        @removeAttachments="removeAttachments($event, attachmentParentType.DEBIT_NOTE)" />
      </div>
</div>
</template>
<script>
import Attachments from '@common/components/Attachments';
import { attachmentParentType } from 'pando-constants';
import { mapGetters } from 'vuex';


export default {
  components: {
    Attachments,
  },
  props: {
    remark: {
      type: String,
      required: true,
    },
    attachmentsTransactionId: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      allowedFileFormats: ['pdf', 'jpeg', 'png'],
      cnAttachments: [],
      dnAttachments: [],
      attachmentParentType,
    };
  },
  computed: {
    ...mapGetters({
      currentClientConfig: 'app/currentClientConfig',
    }),
    cnDnAttachmentLimit() {
      return (this.currentClientConfig.payment_settings
      && this.currentClientConfig.payment_settings.cn_dn_attachment_limit) || 10;
      // default 10
    },
    disableCnUpload() {
      return this.cnAttachments.length >= this.cnDnAttachmentLimit;
    },
    disableDnUpload() {
      return this.dnAttachments.length >= this.cnDnAttachmentLimit;
    },
  },
  methods: {
    setLocalAttachments(attachment, attachmentType) {
      if (attachmentType === this.attachmentParentType.CREDIT_NOTE) {
        this.cnAttachments.push(attachment);
      } else if (attachmentType === this.attachmentParentType.DEBIT_NOTE) {
        this.dnAttachments.push(attachment);
      }
    },
    async addAttachments(file, attachmentType) {
      try {
        const formData = new FormData();
        formData.append('attachment', file.raw);
        formData.append('parent_id', -1); // -1 indicates draft attachment
        formData.append('draft_transaction_id', this.attachmentsTransactionId);
        formData.append('parent_type', attachmentType);
        formData.append('is_draft_attachment', true);
        const result = await this.$store.dispatch('paymentsV2/addInvoiceAttachment', formData);
        if (result && result.error) {
          this.$error({ message: result.error || this.$getErr('UPLOAD_FAILS') });
        } else if (result && result.data) {
          const attachment = {
            name: result.data.content_file_name,
            url: result.data.metadata.location,
            id: result.data.id,
          };
          this.setLocalAttachments(attachment, attachmentType);
          this.$emit('updateValue', 'has_draft_attachments', true);
        } else {
          this.$error({ message: this.$getErr('UPLOAD_FAILS') });
        }
      } catch (err) {
        const apiError = err && err.data && (err.data.messages || (err.data.errors && err.data.errors[0] && err.data.errors[0].messages));
        this.$error({ message: apiError || this.$getErr('UPLOAD_FAILS') });
      }
    },
    async removeAttachmentPostProcess(file, attachmentType) {
      if (attachmentType === attachmentParentType.CREDIT_NOTE) {
        this.cnAttachments = this.cnAttachments.filter(attach => attach.id !== file.id);
      } else if (attachmentType === attachmentParentType.DEBIT_NOTE) {
        this.dnAttachments = this.dnAttachments.filter(attach => attach.id !== file.id);
      }
    },
    async removeAttachments(file, attachmentType) {
      try {
        if (file) {
          let attachLength = 0;
          if (attachmentType === attachmentParentType.CREDIT_NOTE) {
            attachLength = this.cnAttachments.length - 1;
          } else if (attachmentType === attachmentParentType.DEBIT_NOTE) {
            attachLength = this.dnAttachments.length - 1;
          }
          const result = await this.$store.dispatch('paymentsV2/deletInvoiceAttachment', { attachmentId: file.id, attachLength });
          if (result && result.error) {
            this.$error({ message: this.$getErr('DELETE_FILE_FAILS') });
            return;
          }
          await this.removeAttachmentPostProcess(file, attachmentType);
          this.$emit('updateValue', 'has_draft_attachments', !!this.cnAttachments.length || !!this.dnAttachments.length);
        }
      } catch (error) {
        this.$error({ message: this.$getErr('DELETE_FILE_FAILS') });
      } finally {
        this.dialogVisible = false;
      }
    },
  },
};
</script>
